export const matchPrefix = (pattern: RegExp) => (item: string | null) => {
  if (item) {
    const test = item.match(pattern);
    return !!(test && test.length);
  }

  return false;
};
